module.exports = __webpack_public_path__ + "files/002a44a839ee3b8fb82f7e73adfe6cc8.png";